import {
  IStoreInvoiceAllowedStores,
  IStoreInvoiceFilters,
  IStoreInvoiceParams,
  IStoreInvoiceResponse,
  StoreInvoiceExportResult,
} from "src/@types/store-invoice";

import { apiSlice } from "./http";
import { toQueryParams } from "@/utils/to-query-params";

const NO_CONTENT = 204;

async function exportRequestHandler(
  response: Response,
): Promise<StoreInvoiceExportResult> {
  if (response.status === NO_CONTENT) {
    return {};
  }
  return response.json().catch(() => response.text());
}

export const storeInvoiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreInvoices: builder.query<IStoreInvoiceResponse, IStoreInvoiceParams>({
      query: (filters) => ({
        url: `/store-invoice?${toQueryParams(filters)}`,
        method: "GET",
      }),
    }),
    getStoreInvoiceAllowedStores: builder.query<
      IStoreInvoiceAllowedStores,
      void
    >({
      query: () => ({
        url: "/store-invoice/allowed-stores",
        method: "GET",
      }),
    }),
    exportStoreInvoicesExcel: builder.mutation<
      StoreInvoiceExportResult,
      IStoreInvoiceFilters
    >({
      query: (filters) => ({
        url: `/store-invoice/export?${toQueryParams(filters)}`,
        method: "POST",
        responseHandler: exportRequestHandler,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStoreInvoicesQuery,
  useGetStoreInvoiceAllowedStoresQuery,
  useExportStoreInvoicesExcelMutation,
} = storeInvoiceApi;
